<div class="emoji-picker-wrapper">
  <emoji-mart class="emoji-dropdown" (emojiSelect)="select($event)"></emoji-mart>
</div>